import { A as t } from "../../../AntPagination-DhoHKg4V.mjs";
import { p as r } from "../../../styled-components.browser.esm-DBaC0ZEI.mjs";
const i = r(t)`
  padding: var(--space-12);
  background: var(--gray-1);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: sticky;
  left: 120px;
  right: 120px;
  bottom: 0px;
  border-top: 1px solid var(--gray-4);
  border-bottom-left-radius: var(--br-3) !important;
  border-bottom-right-radius: var(--br-3) !important;
  margin-bottom: var(--space-24);
  .ant-pagination-total-text {
    order: -2;
    margin-right: auto;
  }

  .ant-pagination-options {
    order: -1;
    margin-right: 16px;
  }

  [data-icon="down"] {
    fill: var(--primary-7);
  }
`;
export {
  i as StyledPagination
};
//# sourceMappingURL=style.js.map
